import {siPrefix} from "./siPrefix";
import {IScaledNumber, ScaledNumber} from "./ScaledNumber";

/**
 * Created by claudio iozzia on 14/06/2017.
 */
export class ValueFormatter {

  private static precisions: Array<number> =
    [1E0
      , 1E1
      , 1E2
      , 1E3
      , 1E4
      , 1E5
      , 1E6
      , 1E7
      , 1E8
      , 1E9
      , 1E10
      , 1E11
      , 1E12
      , 1E13
      , 1E14
      , 1E15
    ];

  /**
   *
   * @param limitedUnit unita' minima di approssimazione del risultato
   * @return
   *
   */
  public static autoFormat_ll(value: number, limitedUnit: siPrefix, unit: string, prec: number = 2, roundType: string = "r"): string {
    if (isNaN(value)) {
      return "";
    }

    const v: IScaledNumber = ValueFormatter.autoScale(value, prec, roundType);

    if (v.prefix.value > limitedUnit.value) {
      // Coincide con autoFormat;
      return ValueFormatter._format(String(v.value), v.prefix.symbol, unit);
    }

    return ValueFormatter.format(value, limitedUnit, unit, 0, roundType);

    //  else if( v.prefix.value == limitedUnit.value )
    //  {
    //    return format(value, limitedUnit, unit, 0, roundType);
    //  }else
    //    return format(value, limitedUnit, unit, prec, roundType);
  }

  public static autoFormat_sc(value: number, scalePrec: number, unit: string, prec: number = 2, roundType: string = "r"): string {
    if (isNaN(value)) {
      return "";
    }

    value = ValueFormatter.scale(value, siPrefix.unit, scalePrec, roundType); // autoScale(value, prec, roundType);

    return ValueFormatter.autoFormat(value, unit, prec, roundType);
  }

  public static newScaledNumber(value: number, prefix: siPrefix): IScaledNumber {
    return new ScaledNumber(value, prefix);
  }

  public static autoScaled(value: number, prec: number = 2, roundType: string = "r"): number {
    return ValueFormatter.autoScale(value, prec, roundType).value;
  }

  public static autoScale(value: number, prec: number = 2, roundType: string = "r"): IScaledNumber { // Object
    if (value === 0) {
      return ScaledNumber.zero;
    } // {value:0, prefix:siPrefix.unit};

    const round: Function = ValueFormatter.roundFunction(roundType);

    return siPrefix.prefixes
      .map(x => new ScaledNumber(ValueFormatter._scale(value, x, prec, round), x))
      .reduce((acc: ScaledNumber, curr: ScaledNumber) => {
        return (Math.abs(acc.value) < 1E3) ? acc : curr;
      });
  }

  public static autoFormat(value: number, unit: string, prec: number = 2, roundType: string = "r"): string {
    if (isNaN(value)) {
      return "";
    }

    const v: IScaledNumber = ValueFormatter.autoScale(value, prec, roundType);
    return ValueFormatter._format(String(v.value), v.prefix.symbol, unit);
  }

  private static roundFunction(roundType: string = "r"): Function {
    /*
     roundType =
     r --> round
     f --> floor
     c --> ceil
     */
    if (roundType == "f") {
      return Math.floor;
    } else if (roundType == "c") {
      return Math.ceil;
    } else {
      return Math.round;
    }
  }

  private static _scale(num: number, prefix: siPrefix, prec: number, round: Function): number {
    const precision: number = (prec >= 0 && prec < ValueFormatter.precisions.length) ? ValueFormatter.precisions[prec] : 1;
    const value: number = (num / prefix.value) * precision;
    return round(value) / precision;
  }

  public static scale(num: number, prefix: siPrefix, prec: number = 2, roundType: string = "r"): number {
    return ValueFormatter._scale(num, prefix, prec, ValueFormatter.roundFunction(roundType));
  }

  public static fixed_format(num: number, prefix: siPrefix, unit: string, prec: number = 2, roundType: string = "r"): string {
    if (isNaN(num)) {
      return "";
    }

    const scaledValue: Number = ValueFormatter.scale(num, prefix, prec, roundType);
    return ValueFormatter._format(scaledValue.toFixed(prec), prefix.symbol, unit);
  }

  public static format(num: number, prefix: siPrefix, unit: string, prec: number = 2, roundType: string = "r"): string {
    if (isNaN(num)) {
      return "";
    }

    //return format_scaled(newScaledNumber( scale(num, prefix, prec, roundType), prefix), unit);
    return ValueFormatter._format(ValueFormatter.scale(num, prefix, prec, roundType).toString(), prefix.symbol, unit);
  }


  public static format_scaled(scaled: IScaledNumber, unit: string): string {
    const suffix: string = scaled.prefix.symbol + unit;
    if (suffix == "") {
      return scaled.value.toString();
    } else {
      return scaled.value.toString() + " " + suffix;
    }
  }

  private static _format(str: string, prefix_symbol: string, unit: string): string {
    const suffix: string = prefix_symbol + unit;
    if (suffix == "") {
      return str;
    } else {
      return str + " " + suffix;
    }
  }
}
